/**
 * Redo Platform SMS Error Categories
 *
 * Coarse-grained error categories based on business logic requirements.
 * All SMS providers map their specific error codes to these categories.
 */
export enum RedoSmsErrorCategory {
  /** Errors that result in permanent suppression of the phone number */
  PERMANENT_SUPPRESSION = "permanent_suppression",

  /** Errors that result in temporary suppression or retry logic */
  TEMPORARY_SUPPRESSION = "temporary_suppression",

  /** Errors that require phone number validation to determine permanent vs temporary suppression */
  VALIDATION_REQUIRED = "validation_required",

  /** Errors that should trigger alerts/notifications but not suppress the number */
  ALERTABLE = "alertable",

  /** Unknown or unmapped errors that should be handled as general failures */
  UNKNOWN = "unknown",
}
